export const portConstants = {
    PORT_FETCHING: 'PORT_FETCHING',
    PORT_FETCHED: 'PORT_FETCHED',
    PORT_SUBMITTING: 'PORT_SUBMITTING',
    PORT_SUBMITTED: 'PORT_SUBMITTED',
    GET_PORTS: 'GET_PORTS',
    GET_PORT_BY_ID: 'GET_PORT_BY_ID',
    GET_ACTIVE_PORTS: 'GET_ACTIVE_PORTS',
    GET_ACTIVE_PORTS_BRANCH_ORIGIN: 'GET_ACTIVE_PORTS_BRANCH_ORIGIN',
    GET_ACTIVE_PORTS_BRANCH_DESTINATION: 'GET_ACTIVE_PORTS_BRANCH_DESTINATION',
    BRANCH_WITH_PORTS: 'BRANCH_WITH_PORTS'
}